module.exports = __webpack_public_path__ + "img/pB3.90d89e6b.png";